@use 'vars';

.iq-actions-menu {
  display: flex;
  flex-direction: column;
  min-width: 100%;

  &--compact {
    gap: vars.$gap-large;
  }

  &--comfortable {
    display: flex;
  }

  &--stand_alone {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: vars.$gap-small;
    width: 100%;
  }

  & button:last-child {
    margin-bottom: vars.$margin-xxsmall;
  }
}
